import { SetsConfigService } from 'src/services/SetsConfigService';

export const deleteSetsConfig = (
    { accessToken, productKey, signal }: App.SetsConfigs.DeleteMutationVariables,
): Promise<void> => SetsConfigService.deleteSetsConfig(accessToken, productKey, signal);
